import moment from 'moment';
import { isEqual, mapValues, omitBy, pickBy } from 'lodash';

import { campaignsLocallyLoaded } from '../actions/campaigns';
import { ACCOUNT_CHANGED } from '../actionTypes';
import getCampaignIdFromEvent from '../utilities/getCampaignIdFromEvent';
import { CampaignStatuses } from '../constants';

// Only show local campaigns for up to 1 hour.
const VALID_TIME_DELAY = 3600;

const filterCachableCampaigns = (campaigns) => {
  const omitStatuses = [CampaignStatuses.sending, CampaignStatuses.cancelling];
  return pickBy(campaigns, campaign => omitStatuses.indexOf(campaign.status.toString()) === -1);
};

const handleLocalCampaigns = (storage, beforeState, afterState, action, store) => {
  // Load from cache.
  if (action.type === ACCOUNT_CHANGED) {
    const validAfter = moment().unix() - VALID_TIME_DELAY;
    const campaigns = omitBy(
      (storage.get('localCampaigns') || {})[action.address] || {},
      campaign => campaign.lastTouched && campaign.lastTouched < validAfter,
    );
    store.dispatch(campaignsLocallyLoaded(campaigns));
    return;
  }

  // Only update if we have a campaign, campaignId, or event on the action, and we have an address.
  if ((action.campaign || action.campaignId || action.event) && afterState.account.address) {
    const campaignId =
      action.campaignId ||
      (action.campaign ? action.campaign.id : getCampaignIdFromEvent(action.event));
    // Update cache if content has changed.
    if (!isEqual(beforeState.campaigns.localCampaigns, afterState.campaigns.localCampaigns)) {
      const {
        account: { address },
        campaigns: { localCampaigns },
      } = afterState;
      storage.set('localCampaigns', {
        ...(storage.get('localCampaigns') || {}),
        [address]: filterCachableCampaigns(mapValues(localCampaigns, campaign => ({
          ...campaign,
          tokensPerCode: campaign.tokensPerCode.toString(),
          status: campaign.status.toString(),
          lastTouched: campaignId === campaign.id ? moment().unix() : campaign.lastTouched,
        }))),
      });
    }
  }
};

export default handleLocalCampaigns;



// WEBPACK FOOTER //
// ./src/middleware/localCampaignsPersistence.js